// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"11":"a4ad4e77","491":"60adfb18","583":"6d198f8c"}[chunkId] + ".chunk.js";
};